import Axios from 'axios';

export default {
  GetKey: domainId => Axios.post('ECM/ReturnKey', { domainId }),
  GetDocuments: (domainId, keyValues) => Axios.post('ECM/GetContextDocuments', { domainId, keyValues }),
  DeleteDocument: documentHash => Axios.post('ECM/deletedocument', { documentHash }),
  DownloadDocument: documentHash => Axios.post('ECM/GetDocument', { documentHash }),
  DownloadDocuments: (documentHashes) => Axios.post('ECM/DownloadDocuments', { documentHashes }),
  ReturnImageContent: documentHash => Axios.post('ECM/ReturnImageContent', { documentHash }),
  GetDocumentGroup: idDomain => Axios.post('ECM/GetDocumentGroup', { idDomain }),
  GetDocumentType: documentGroupId => Axios.post('ECM/GetDocumentType', { documentGroupId }),
  GetDomDocumentType: documentTypeId => Axios.post('ECM/GetDomDocumentType', { documentTypeId }),
  GetDocumentDetail: documentHash => Axios.post('ECM/GetDocumentDetail', { documentHash }),
  UpdateDocument: params =>
    Axios.put('ECM', {
      documentId: params.documentId,
      hash: params.hash,
      idDocumentType: params.id_tp_document,
      referenceNumber: params.nr_reference,
      observation: params.observation,
      documentDate: params.dt_document,
      tagName: params.tag
    }),

  InsertDocument: (params, domain, key, user) => {
    let fields = {
      idDomain: domain,
      keyValues: key,
      idDocumentType: params.id_tp_document,
      referenceNumber: params.nr_reference,
      documentDate: params.dt_document,
      observation: params.observation,
      tagName: params.tag,
      user: user,
      geoCoordinates: '',
      geoArea: '',
      geoPerimeter: '',
      geoMap: '',
      geoZoom: ''
    };

    let form = new FormData();

    for (let file in params.files) {
      let f = 'file' in params.files[file] ? params.files[file].file : params.files[file];
      form.append('file', f, f.name);
    }

    form.append('params', JSON.stringify(fields));

    return Axios.post('ECM/InsertDocument', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};
